import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "phoneNumber",
  "use": "phoneNumber-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"phoneNumber\"><path fill=\"#37F\" fill-rule=\"nonzero\" d=\"M10.36.42h-7c-.653 0-1.167.513-1.167 1.167v10.826c0 .654.514 1.214 1.214 1.214H10.36c.653 0 1.213-.514 1.213-1.214V1.587C11.573.933 11.06.42 10.36.42Zm-4.62.84h2.333a.2.2 0 0 1 .187.187.2.2 0 0 1-.187.186H5.74a.2.2 0 0 1-.187-.186c0-.094.047-.187.187-.187Zm1.12 11.433a.837.837 0 0 1-.84-.84c0-.466.373-.84.84-.84.467 0 .84.374.84.84 0 .467-.373.84-.84.84Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol